import { Container } from "../atoms/Container";
import { SunriseMark } from "../atoms/SunriseMark";

type SiteNavProps = {
  mobile?: boolean;
};

export function SiteNav({ mobile = false }: SiteNavProps) {
  const pad = mobile ? 24 : 96;
  return (
    <nav
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        background: "color-mix(in oklab, var(--bg) 88%, transparent)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        borderBottom: "0.5px solid var(--hairline)",
      }}
    >
      <Container pad={pad}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            height: mobile ? 60 : 72,
          }}
        >
          <a
            href="#top"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              textDecoration: "none",
              color: "var(--text)",
            }}
          >
            <SunriseMark size={28} />
            <span
              style={{
                fontFamily: "var(--display)",
                fontSize: 16,
                letterSpacing: "-0.01em",
                fontWeight: 400,
              }}
            >
              My First Marathon
            </span>
          </a>
          <a
            href="#join"
            style={{
              fontFamily: "var(--ui)",
              fontSize: 14,
              fontWeight: 500,
              color: "var(--text)",
              textDecoration: "none",
              borderBottom: "0.5px solid var(--text)",
              paddingBottom: 1,
              letterSpacing: "-0.005em",
            }}
          >
            Join the waitlist.
          </a>
        </div>
      </Container>
    </nav>
  );
}
